import { render, staticRenderFns } from "./AnalysisBusinessRiskGroup.vue?vue&type=template&id=14c180c8&"
import script from "./AnalysisBusinessRiskGroup.vue?vue&type=script&lang=js&"
export * from "./AnalysisBusinessRiskGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports